(()=>{
  'use strict';
  const dialog=document.getElementById('ZqNewsletterExit');
  if(!dialog||typeof dialog.showModal!=='function'||dialog.dataset.bound)return;
  dialog.dataset.bound='true';
  const params=new URLSearchParams(location.search);
  const preview=params.get('newsletter_preview')==='1';
  const key='zq_newsletter_exit_v1';
  const subscribedKey='zq_newsletter_subscribed';
  const started=Date.now();
  const coarse=matchMedia('(hover: none), (pointer: coarse)').matches;
  let shown=false;
  let returnFocus=null;
  let previousOverflow='';
  const read=(storage,name)=>{try{return storage.getItem(name)}catch{return null}};
  const write=(storage,name,value)=>{try{storage.setItem(name,value)}catch{}};
  const storage=kind=>{try{return window[kind]}catch{return {getItem:()=>null,setItem:()=>{}}}};
  const local=storage('localStorage');
  const session=storage('sessionStorage');
  const suppressed=()=>read(local,subscribedKey)==='1'||read(session,key)==='1'||Date.now()-Number(read(local,key)||0)<7*24*60*60*1000;
  const show=force=>{
    if(shown||document.visibilityState!=='visible'||(!force&&suppressed())||document.querySelector('dialog[open]'))return;
    const active=document.activeElement;
    if(!force&&active?.matches('input,textarea,select,[contenteditable="true"]'))return;
    returnFocus=active;
    dialog.showModal();
    shown=true;
    write(session,key,'1');
    previousOverflow=document.documentElement.style.overflow;
    document.documentElement.style.overflow='hidden';
    dialog.querySelector('[data-zqe-close]')?.focus({preventScroll:true});
  };
  const close=()=>dialog.close();
  dialog.querySelector('[data-zqe-close]')?.addEventListener('click',close);
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const rect=dialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close();
  });
  dialog.addEventListener('close',()=>{
    document.documentElement.style.overflow=previousOverflow;
    write(local,key,String(Date.now()));
    if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});
  });
  const success=dialog.querySelector('[data-zqe-success]');
  const inlineSuccess=document.querySelector('#ZqNewsletterPanel .zqn-success');
  if(success||inlineSuccess||params.get('customer_posted')==='true'){
    write(local,subscribedKey,'1');
    if(success&&location.hash==='#ZqExitNewsletterForm')show(true);
    return;
  }
  if(dialog.querySelector('[data-zqe-errors]')&&location.hash==='#ZqExitNewsletterForm'){show(true);return}
  if(preview){show(true);return}
  document.addEventListener('mouseout',event=>{
    if(!coarse&&!event.relatedTarget&&event.clientY<=0&&Date.now()-started>=8000)show(false);
  });
  let mobileReady=false;
  const mobileOffer=()=>{
    const scrollable=document.documentElement.scrollHeight-innerHeight;
    if(mobileReady&&coarse&&scrollY>=Math.min(240,scrollable*.2))show(false);
  };
  if(coarse){setTimeout(()=>{mobileReady=true;mobileOffer()},35000);addEventListener('scroll',mobileOffer,{passive:true})}
})();
